export function getEhsCode(vehicle) {
    let code = '';

    //check for comfort and luxury type
    const ehsType = vehicle.type.key;
    if (ehsType == 'comfort') code = 'MFPBSC2B6D';
    if (ehsType == 'luxury') code = 'MFPBSD1B6D';

    //check for redinterior, default is black interior
    if (vehicle.options.redinterior && vehicle.options.redinterior.selected) {
        code = code + 'W';
    } else code = code + 'B';

    if (ehsType == 'phev-comfort-fr') {
        code = 'MFRUSCHH5DL';
        if (vehicle.color.key == 'pearl-white') code = 'MFRUSCJH5DL';
    }

    if (ehsType == 'phev-luxury-fr') {
        code = 'MFRUSGBH5DL';
        if (vehicle.color.key == 'pearl-white') code = 'MFRUSG3H5DL';
        if (vehicle.options && vehicle.options['brown-interior'].selected) {
            code = 'MFRUSGBH5DS';
            if (vehicle.color.key == 'pearl-white') code = 'MFRUSGCH5DS';
        }
    }

    return code;
}

export function getEhsHybridPlusCode(vehicle) {
    let code = '';

    const ehsType = vehicle.type.key;

    if (ehsType == 'comfort') {
        code = 'MFRYSC1H5DL';
        if (vehicle.color.key == 'pearl-white') code = 'MFRYSC2H5DL';
    }

    if (ehsType == 'luxury') {
        code = 'MFRYSG3H5DL';
        if (vehicle.color.key == 'pearl-white') code = 'MFRYSG4H5DL';
        if (vehicle.options && vehicle.options['brown-interior'].selected) {
            code = 'MFRYSG3H5DS';
            if (vehicle.color.key == 'pearl-white') code = 'MFRYSG4H5DS';
        }
    }

    return code;
}

export function getMarvelRCode(vehicle) {
    let code = '';

    //check for comfort, luxury and performance type
    const marvelRType = vehicle.type.key;

    if (marvelRType == 'comfort') code = 'MGP3SD19DCL'; //default black interior;
    if (marvelRType == 'luxury') {
        if (vehicle.options.greyInterior.selected)
            code = 'MGP3SD59DCD'; //with grey interior
        else code = 'MGP3SD39DCL'; //with black interior
    }
    if (marvelRType == 'performance') {
        if (vehicle.options.greyInterior.selected) code = 'MGP3SG49ECD';
        else code = 'MGP3SG29ECL';
    }
    return code;
}

export function getZsEvCode(vehicle) {
    let code = '';

    const zsEvType = vehicle.type.key;
    if (zsEvType == 'comfort') {
        const versionKey = vehicle.version.key;
        if (versionKey == 'standard-range') code = 'MDPCSC19KC';
        if (versionKey == 'long-range') code = 'MDPCSC39KC';
    }
    if (zsEvType == 'luxury') {
        const versionKey = vehicle.version.key;
        if (versionKey == 'standard-range') code = 'MDPCSD39KC';
        if (versionKey == 'long-range') code = 'MDPCSD99KC';
    }

    return code + 'C';
}

export function getZsCode(vehicle) {
    let code = '';

    const zsType = vehicle.type.key;
    if (zsType == 'comfort') code = 'MDPESC2BK1';
    if (zsType == 'luxury') {
        const versionKey = vehicle.version.key;
        if (versionKey == 'comfort-engine-5') code = 'MDPESD2BK1';
        if (versionKey == 'comfort-engine-6') code = 'MDPESD2B14';
    }

    return code + 'C';
}

export function getMg5Code(vehicle) {
    let code = '';

    const mg5Type = vehicle.type.key;
    const versionKey = vehicle.version.key;
    if (mg5Type == 'comfort') {
        if (versionKey == 'standard-range') code = 'MGP2TC19LCL'; // + black interior
        if (versionKey == 'extended-range') code = 'MGP2TC59LCL'; // + black interior
    }
    if (mg5Type == 'luxury') {
        if (versionKey == 'standard-range') {
            if (vehicle.options.greyInterior.selected)
                code = 'MGP2TD19LCC'; // + grey interior
            else code = 'MGP2TD19LCL';
        }

        if (versionKey == 'extended-range') {
            if (vehicle.options.greyInterior.selected)
                code = 'MGP2TD49LCC'; // + grey interior
            else code = 'MGP2TD49LCL';
        }
    }

    return code;
}

export function getMg4Code(vehicle) {
    let code = '';

    const mg4Type = vehicle.type.key;

    if (mg4Type == 'standard') code = 'MGR4FT19RCL'; // + black interior
    if (mg4Type == 'comfort') code = 'MEPVFC19RCL'; // + black interior
    if (mg4Type == 'luxury') {
        if (vehicle.options && vehicle.options['luxury-grey-interior'].selected)
            code = 'MEPVFD29RC1'; // greyinterior
        else code = 'MGR4FD29RCL';
    }
    if (mg4Type == 'trophy') {
        if (vehicle.options && vehicle.options['luxury-grey-interior'].selected)
            code = 'MEPXFDA9TC1'; // greyinterior
        else code = 'MEPXFDA9TCL';
    }
    if (mg4Type == 'xpower') {
        if (vehicle.color.productCode == 'GWH')
            code = 'MGR4FG19SCL'; // GWH - Hunter Green color
        else code = 'MGR4FG39SCL';
    }

    return code;
}

export function getMg3Code(vehicle) {
    let code = '';

    const mg3Type = vehicle.type.key;
    if (mg3Type == 'standard') code = 'MJSBFT1H1LL';
    if (mg3Type == 'comfort') code = 'MJSBFC1H1LL';
    if (mg3Type == 'luxury') code = 'MJSBFD1H1LL';

    return code;
}

export function getMgZsHevCode(vehicle) {
    let code = '';

    const mgZsHevType = vehicle.type.key;
    if (mgZsHevType == 'standard') code = 'MDSW1T01PLL';
    if (mgZsHevType == 'comfort') code = 'MDSW1D01RLL';
    if (mgZsHevType == 'luxury') code = 'MDSW1G01TLL';

    return code;
}

export function getMgS5Code(vehicle) {
    let code = '';

    const mgS5Type = vehicle.type.key;
    const versionKey = vehicle.version.key;
    if (versionKey == 'long-range') {
        if (mgS5Type == 'comfort') code = 'MJR81C00KCL';
        if (mgS5Type == 'luxury') code = 'MJR81D00QCL';
    }
    if (versionKey == 'standard-range') {
        if (mgS5Type == 'comfort') code = 'MJR81C00FCL';
    }

    return code;
}
